import { render, staticRenderFns } from "./must-label.vue?vue&type=template&id=5fa1d4a8&scoped=true"
import script from "./must-label.vue?vue&type=script&lang=js"
export * from "./must-label.vue?vue&type=script&lang=js"
import style0 from "./must-label.vue?vue&type=style&index=0&id=5fa1d4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1d4a8",
  null
  
)

export default component.exports